import { instance } from "./AxiosErrorComp";




class ApiService{
  constructor(){}

  
  async get(resource, params) {
		try {
      let config = null;
      if (params) {
        config = {...params };
      }
			const response = await instance.get(resource, config);
			  if(response?.status>=200&&response?.status<299) {
				return response;
			} else {
				throw new Error('get query failed');
			}
		} catch (err) {
			throw new Error(`ApiService ${err}`);
		}
	}
  async delete(resource) {
		try {
      
			const response = await instance.delete(resource);
			  if(response?.status>=200&&response?.status<299) {
				return response;
			} else {
				throw new Error('get query failed');
			}
		} catch (error) {
			throw new Error(`ApiService ${error}`);
		}
	}
  async post(resource,params) {
		try {
      let config = null;
      if (params) {
        config = {...params };
      }
			const response = await instance.post(resource,params);
			  if(response?.status>=200&&response?.status<299) {
				return response;
			} else {
				throw new Error('get query failed');
			}
		} catch (error) {
      console.log(error)
			throw new Error(`ApiService`);
		}
	}
  async put(resource,params) {
		try {
      let config = null;
      if (params) {
        config = {...params };
      }
			const response = await instance.put(resource,params);
			  if(response?.status>=200&&response?.status<299) {
				return response;
			} else {
				throw new Error('get query failed');
			}
		} catch (error) {
			throw new Error(`ApiService `);
		}
	}
  login(data){
    return this.post('/users/login-user',data)
  }
  getUsers(data){
      return this.post(`/users/user-list`,data)
  }
  getAdmins(data){
    return this.post(`/users/admin-list`,data)
}
createUSer(data){
  return this.post('/users/create-user',data)
}
toggleUser(id){
  return this.put(`/users/${id}/toggle-active-user`)
}
changePass(data){
  return this.post('/users/change-user-password',data)
}
getDataFarm(data){
    return this.post(`/farms/sensors`,data)
}
getPens(data){
    
      return this.post(`/farms/current-farm-pens`,data)
}
  
getTypePens(data){
      return this.post('/pens/get-pen-types',data); 
}
addPenType(data){
  return this.post('/pens/pen-type',data)
}
editPenType(data){
  return this.put('/pens/pen-type',data)
}
getFarmsList(data){
  return this.post('/farms/list-farms',data)
}

getFarms(){
    return this.get('/farms')
}
getDashboardStats(data){
  return this.post(`/farms/current-farm-herd-stats`,data);
}
getFarmInfo(){
  return this.get(`/farms/current-farm`)
}
getSinglePen(id,data){
  return this.post(`/pens/${id}/cattles`,data)
}
getPackets(data){
  return this.post(`/farms/collectors`,data)
}
getCattleCommetns(data){
  return this.post(`/cattles/current-user-cattle-comment-list`,data)
}
getSensorCommetns(data){
  return this.post(`/sensors/sensor-comment-list`,data)
}
getCattle(id){
  return this.get(`/cattles/${id}`)
}
getCattleStats(data){
  return this.post(`/cattles/stats`,data)
}
getPacket(id){
  return this.get(`/collectors/${id}`)
}
getSensor(id){
  return this.get(`/sensors/${id}`)
}
getSensorLogs(id,data){
  return this.post(`/sensors/${id}/logs-list`,data)
}
getCattleComment(){
  return this.get(`/cattles/cattle-comment-types`)
}
addTypeCattleComment(data){
  return this.post(`/cattles/cattle-comment-type`,data)
}
editTypeCattleComment(data){
  return this.put(`/cattles/cattle-comment-type`,data)
}
addPensComments(data){
  return this.post(`/pens/create-pen-comments`,data)
}
getPensCommentsTypes(){
  return this.get(`/pens/pen-comment-types`)
}
editPensCommentsTypes(data){
  return this.put(`/pens/pen-comment-type`,data)
}
addPensCommentsTypes(data){
  return this.post(`/pens/pen-comment-type`,data)
}
getPensCommentList(data){
  return this.post(`/pens/current-user-pen-comment-list`,data)
}
getSensorComment(){
  return this.get(`/sensors/sensor-comment-types`)
}
addTypeSensorComment(data){
  return this.post(`/sensors/sensor-comment-type`,data)
}
editTypeSensorComment(data){
  return this.put(`/sensors/sensor-comment-type`,data)
}
addNewComment(data){
  return this.post(`/cattles/create-cattle-comments`,data)
}
addNewSensorComment(sensorId,data){
  return this.post(`/sensors/${sensorId}/sensor-comment`,data)
}
addNewCattle(data){
  return this.post('/cattles',data)
}
addNewSensor(data){
  return this.post('/sensors',data)
}
addNewPen(data){
  return this.post('/pens',data)
}
addNewFarm(data){
  return this.post('/farms',data)
}
addNewCollector(data){
  return this.post('/collectors',data)
}
deleteCattle(cattleId){
  return this.delete(`/cattles/${cattleId}`)
}
deleteFarm(farmId){
  return this.delete(`/farms/${farmId}`)
}
deletePen(penId){
  return this.delete(`/pens/${penId}`)
}
updatePen(penId,data){
  return this.put(`/pens/${penId}`,data)
}
updateCattleComment(id,data){
  return this.put(`/cattles/${id}/cattle-comment`,data)
}
updateSensorComment(id,data){
  return this.put(`/sensors/${id}/sensor-comment`,data)
}
updateCattle(cattleId,data){
  return this.put(`/cattles/${cattleId}`,data)
}
updateFarm(farmId,data){
  return this.put(`/farms/${farmId}`,data)
}
updateSensor(penId,data){
  return this.put(`/sensors/${penId}`,data)
}
updateCollector(id,data){
  return this.put(`/collectors/${id}`,data)
}
toggleSensor(id){
  return this.put(`/sensors/${id}/toggle-active-sensor`)
}
togglePenType(id){
  return this.put(`/pens/${id}/toggle-active-pen-type`)
}
//terminals

getTerminals(data){
  return this.post(`/farms/terminals`,data)
}
getTerminal(id){
  return this.get(`/terminals/${id}`)
}
editTerminal(id,data){
  return this.put(`/terminals/${id}`,data)
}
addTerminals(data){
  return this.post(`/terminals`,data)
}
toggleTerminal(id){
  return this.put(`/terminals/${id}/toggle-active-terminal`)
}
deleteCommentSensor(id){
  return this.delete(`/sensors/${id}/sensor-comment`)
}
deleteCommentCattle(id){
  return this.delete(`/cattles/${id}/cattle-comment`)
}
changePen(id,data){
  return this.put(`/cattles/${id}/pen`,data)
}
getCattleHistory(data){
  return this.post(`/cattles/cattle-status-history-list-by-user`,data)
}
getCattleParamHistory(id,data){
  return this.post(`/cattles/${id}/cattle-history-list-by-user`,data)
}
getCattleHistoryParameters(id,data){
  return this.post(`/cattles/${id}/cattle-history-list-by-user`,data)
}
getCattleHistoryCycle(data){
  return this.post(`/cattles/cattle-life-cycle-history-list-by-user`,data)
}
getSensorHistory(id,data){
  return this.post(`/sensors/${id}/sensor-status-history-list`,data)
}
getSensorHistoryParameters(id,data){
  return this.post(`/sensors/${id}/sensor-history-list`,data)
}
getSensorsPacketList(id){
  return this.get(`/farms/${id}/check-sensors-status`)
}
getTicketStatus(){
  return this.get(`/ticket/get-ticket-status-list`)
}
getTickets(data){
  return this.post(`/ticket/current-create-user-ticket-list`,data)
}
AddTicket(data){
  return this.post(`/ticket`,data)
}
toggleTicket(id){
  return this.put(`/ticket/${id}`)
}
responseTicket(id,data){
  return this.put(`/ticket/${id}/answer-ticket`,data)

}
getAllCattles(data){
  return this.post(`/farms/current-farm-cattles`,data)
}
getFatmsStatus(data){
  console.log(data)
  return this.post(`/farms/get-current-farm-status`,data)
}
getStatusList(){
  return this.get('/cattles/cattle-status-list')
}
getSensorStatusList(){
  return this.get('/sensors/sensor-status-list')
}
updateUSerINfo(id,data){
  return this.put(`/users/${id}`,data)
}
//cycle
getCattleCycleStatusList(){
  return this.get(`/cattles/cattle-life-cycle-list`)
}
changeCattleLifeCycle(id,data){
  return this.put(`/cattles/${id}/change-cattle-life-cycle`,data)
}
changeCattleStatus(id,data){
  return this.put(`/cattles/${id}/change-cattle-status`,data)
}
editStatusItem(data){
  return this.put(`cattles/cattle-status`,data)
}
addStatusItem(data){
return this.post(`cattles/cattle-status`,data)}
editStatusSensor(data){
  return this.put(`sensors/sensor-status`,data)
}
addStatusSensor(data){
return this.post(`sensors/sensor-status`,data)}
editCycleItem(data){
  return this.put(`cattles/cattle-life-cycle`,data)
}
addCycleItem(data){
return this.post(`cattles/cattle-life-cycle`,data)}
getOrderCycle(){
  return this.get(`cattles/cattle-life-cycle-order-list`)
}
addOrderCycle(data){
  return this.post(`cattles/cattle-life-cycle-order`,data)
}
editOrderCycle(id,data){
  return this.put(`cattles/${id}/cattle-life-cycle-order`,data)
}
deleteOrderCycle(id){
  return this.delete(`cattles/${id}/cattle-life-cycle-order`)
}
toggleActiveCollectors(id){
  return this.put(`collectors/${id}/toggle-active-collector`)
}
updatePenComment(id,data){
  return this.put(`/pens/${id}/pen-comment`,data)
}
deletePenComment(id){
  return this.delete(`/pens/${id}/pen-comment`,id)
}
getCommentsFarm(data){
  return this.post(`/farms/current-user-farm-comment-list`,data)
}
getCommentFarmTypes(){
  return this.get(`/farms/farm-comment-types`)
}
addCommentFarmTypes(data){
  return this.post(`/farms/farm-comment-type`,data)
}
editCommentFarmTypes(data){
  return this.put(`/farms/farm-comment-type`,data)
}
addFarmComment(data){
  return this.post(`/farms/current-user-create-farm-comments`,data)
}
editFarmComment(id,data){
  return this.put(`/farms/${id}/farm-comment`,data)
}
deleteFarmComment(id){
  return this.delete(`/farms/${id}/farm-comment`)
}
readStatusHistory(id){
  return this.put(`/cattles/${id}/read-cattle-status-history`)
}
readCycleHistory(id){
  return this.put(`/cattles/${id}/read-cattle-life-cycle-history`)
}
getImportanceLevelList(){
  return this.get(`/general/get-importance-level-list`)
}
getDetailsCattleStatus(){
  return this.get(`/cattles/get-cattle-status-detail-list`)
}
getAdminList(data){
  return this.post(`/users/admin-list`,data)
}
addAdmin(data){
  return this.post(`/users/create-admin`,data)
}
getOtpForgetPass(query){
  return this.get(`/users/get-otp-forget-password?username=${query}`)
}
verifyOtpForgetPassword(data){
  return this.put(`/users/verify-otp-forget-password`,data)
}
getDetailsCattleStatus(){
  return this.get(`/cattles/get-cattle-status-detail-list`)
}
}

const apiService = new ApiService();

export default apiService

